export default (theme: any) => ({
    dialogPaper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        padding: '34px !important',
        '@media (max-width: 599px)': {
            margin: '24px 16px',
            width: 'auto',
            maxWidth: 'calc(100% - 32px)',
            borderRadius: '20px',
        },
    },

    dialogPaperPopup: {
        maxWidth: '85%',
        [theme.breakpoints.up('xl')]: {
            maxWidth: '55%',
        },
        '@media (max-width: 599px)': {
            maxWidth: '85%',
            width: '85%',
            margin: '0 auto',
        },
    },

    dialogContentContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        flex: 1,
        rowGap: '12px',
    },

    dialogContentContainerTop: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        flex: 1,
    },

    dialogTitle: {
        color: theme.palette.typography.main,
        margin: 0,
        fontSize: '1.563rem',
        fontWeight: 800,
    },
    dialogSubTitle: {
        color: theme.palette.typography.half,
        margin: 0,
        fontSize: '1.063rem',
        fontWeight: 600,
    },

    dialogTitleColored: {
        color: theme.palette.secondary.dark,
        margin: 0,
        fontSize: '2rem',
        fontWeight: 800,
    },

    dialogTitleContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },

    dialogCloseContainer: {
        border: `1.5px solid ${theme.palette.typography.main}`,
        borderRadius: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.5rem',
    },

    dialogCloseIcon: {
        color: theme.palette.textPrimaryColor.main,
        '& svg': {
            fontSize: '1.5rem',
        },
        padding: '0px',
    },

    dialogContainerTitle: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        columnGap: '34px',
    },

    dialogContent: {
        width: '100%',
        padding: '16px 0px',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            alignItems: 'center',
        },
    },

    dialogActions: {
        width: '100%',
        flex: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        flexDirection: 'column',
        gap: '1rem',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        },
        padding: '0px !important',
    },

    deleteButton: {
        color: 'red',
        borderColor: 'red',
    },

    buttonProgress: {
        position: 'absolute',
        top: 'calc(50% - 12px)',
        left: 'calc(50% - 12px)',
        '& .MuiCircularProgress-circle': {
            stroke: '#ffffff',
            strokeWidth: 3,
        },
        '&::before': {
            borderColor: 'rgba(255, 255, 255, 0.5)',
            borderWidth: 2,
        },
    },

    button: {
        width: '100%',
        padding: '1.3rem',
    },
})
